package com.appsyde.shared.modules.account.domain.usecase

import com.appsyde.shared.modules.account.domain.model.CustomerPortalSession
import com.appsyde.shared.modules.account.domain.repository.AccountRepository

class CreateCustomerPortalSessionUseCase(
    private val accountRepository: AccountRepository
) {
    suspend operator fun invoke(): CustomerPortalSession? = accountRepository.createCustomerPortalSession()
}
